import styled from '@emotion/styled';

// TODO this should probably be a strong or a span but not a b
const SubtopicTitle = styled('b')({
  fontWeight: 500,
});

export default SubtopicTitle;
